import Vue from "vue";
import { createDecipher } from "crypto";
import { filter } from "@progress/kendo-data-query/dist/npm/transducers";
import { bus } from "../../../main";
import moment from "moment";

export default {
	props: {
		field: String,
		title: String,
		sortable: [Boolean, Object],
		sort: null,
		filterable: false,
		isInEditMode: false,
		tableName: "",
		headerType: "",
		switchValue: { default: false, type: Boolean },
		imageReadOnly: String,
		imageBooleanOn: String,
		tooltipValueOn: String,
		imageBooleanOff: String,
		tooltipValueOff: String,

		tooltipValueImage:String,

		filterType: "",
		itemsForFilter: Array,
		filterItemsSelected: Array,
		showActiveByElements: { default: false, type: Boolean },
		filterTooltipClass: String
	},

	data: function() {
		return {
			show: false,
			filterText: "",
			localSwitchValue: this.switchValue,
			sortDirection: "asc",
			filterMultiSelectText: "",
			startDateHeader: null,
			endDateHeader: null,
			startTimeHeader: null,
			endTimeHeader: null,
			datePickerFooter: "Oggi - #=kendo.toString(data, 'dd MMMM yyyy') #",
			filterRadioOptions: [
				{ text: "SI", value: true },
				{ text: "NO", value: false }
			],
			filterRadioButtonSelected: null,
			isFilterActive: false
		};
	},

	watch: {
		isInEditMode: function (newValue) {
			if (newValue) {
				this.show = false;
			}
		},
		switchValue: function(newValue) {
			this.localSwitchValue = newValue;
		},
		filterItemsSelected: function(items) {
			if (items && items.length == 0 && this.isFilterActive) this.isFilterActive = false;
		}
	},

	created() {
		bus.$on("close-all-header-filter", this.closeFilterTooltip.bind(this));
	},

	methods: {
		startTimeChange(item) {
			var newTimeDate = moment(item.sender.value());
			if (newTimeDate > moment(this.endTimeHeader)) {
				var ts = moment(item.sender.value()).add(30, "minutes");
				this.endTimeHeader = ts;
			}
			this.startTimeHeader = newTimeDate;
		},
		endTimeChange(item) {
			var newEndTime = moment(item.sender.value());
			if (newEndTime < moment(this.startTimeHeader)) {
				var ts = moment(item.sender.value()).add(-30, "minutes");
				this.startTimeHeader = ts;
			}
			this.endTimeHeader = newEndTime;
		},

		startDateChange(item) {
			if (item.sender.value()) {
				var newStartDate = moment(item.sender.value());
				if (newStartDate > moment(this.endDateHeader)) {
					this.endDateHeader = newStartDate;
				}
				this.startDateHeader = newStartDate;
			} else {
				this.startDateHeader = null;
			}
		},

		endDateChange(item) {
			if (item.sender.value()) {
				var newEndDate = moment(item.sender.value());
				if (newEndDate < moment(this.startDateHeader)) {
					this.startDateHeader = newEndDate;
				}
				this.endDateHeader = newEndDate;
			} else {
				this.endDateHeader = null;
			}
		},
		startDateTimeChange(item) {
			var newStartDate = moment(item.sender.value());
			// if (newStartDate > moment(this.endDateHeader)) {
			// 	this.endDateHeader = newStartDate;
			// }
			this.startDateHeader = newStartDate;
		},

		endDateTimeChange(item) {
			var newEndDate = moment(item.sender.value());
			// if (newEndDate < moment(this.startDateHeader)) {
			// 	this.startDateHeader = newEndDate;
			// }
			this.endDateHeader = newEndDate;
		},
		closeFilterTooltip(idSource) {
			var id = `${this.tableName}${this.field}`;
			if (idSource != id) this.show = false;
		},
		showFilter: function() {
			bus.$emit("close-all-header-filter", `${this.tableName}${this.field}`);

			if (this.isInEditMode == false) {
				this.show = !this.show;
			} else {
				this.show = false;
			}
		},
		clickHandler: function(e) {
			if (!this.isInEditMode && this.sortable) this.$emit("header-click", this);
		},
		filterHandler: function(e) {
			if (!this.isInEditMode) {
				this.$emit("filter-click", this);
				this.isFilterActive = true;
			}
			this.show = false;
		},
		removeFilter: function(e) {
			if (!this.isInEditMode) this.$emit("remove-filter-click", this);
			this.filterText = "";
			this.startDateHeader = null;
			this.endDateHeader = null;
			this.filterRadioButtonSelected = null;

			this.show = false;
			this.isFilterActive = false;
		},
		switchChange() {
			if (!this.isInEditMode) this.$emit("header-switch-change", !this.localSwitchValue);
		},
		switchImageChange() {
			if (!this.isInEditMode) this.$emit("header-switch-change", !this.localSwitchValue);
		},
		changeItemSelection(item) {
			if (item.selected) {
				var i = this.filterItemsSelected.findIndex(x => {
					return x == item.id;
				});

				if (i >= 0) {
					this.filterItemsSelected.splice(i, 1);
				}
			} else {
				this.filterItemsSelected.push(item.id);
			}
		}
	},

	computed: {
		isFilterActiveComp() {
			return this.isFilterActive || (this.showActiveByElements && this.filterItemsSelected && this.filterItemsSelected.length > 0);
		},
		customTooltipFilterClass() {
			return `${this.filterTooltipClass} ${this.filterType == 'boolean' ? ' smallInT' : ''}`;
		},
		startTimeString() {
			if (this.startTimeHeader) {
				return moment(this.startTimeHeader).format("HH:mm");
			}

			return "";
		},
		endTimeString() {
			if (this.endTimeHeader) {
				return moment(this.endTimeHeader).format("HH:mm");
			}

			return "";
		},
		startDateString() {
			if (this.startDateHeader) {
				return moment(this.startDateHeader).format("DD/MM/YYYY");
			}

			return "";
		},
		endDateString() {
			if (this.endDateHeader) {
				return moment(this.endDateHeader).format("DD/MM/YYYY");
			}

			return "";
		},
		startDateTimeString() {
			if (this.startDateHeader) {
				return moment(this.startDateHeader).format("DD/MM/YYYY HH:mm");
			}

			return "";
		},
		endDateTimeString() {
			if (this.endDateHeader) {
				return moment(this.endDateHeader).format("DD/MM/YYYY HH:mm");
			}

			return "";
		},
		filterItems: function() {
			var self = this;
			var itemsToShow = [];

			var itemsFilteredBySelectFilter = this.itemsForFilter;

			if (self.filterMultiSelectText) {
				itemsFilteredBySelectFilter = itemsFilteredBySelectFilter.filter(function(o) {
					return o.value.toLowerCase().indexOf(self.filterMultiSelectText.toLowerCase()) >= 0;
				});
			}

			for (var i = 0; i < itemsFilteredBySelectFilter.length; i++) {
				var item = itemsFilteredBySelectFilter[i];
				var isSelected =
					this.filterItemsSelected.findIndex(x => {
						return x == item.id;
					}) >= 0;

				itemsToShow.push({
					id: item.id,
					value: item.value,
					selected: isSelected
				});
			}

			return itemsToShow;
		},
		showSort() {
			if (this.sortable && this.sort) {
				var self = this;
				if (Array.isArray(this.sort)) {
					var findField = this.sort.find(function(item) {
						return item.field === self.field;
					});
					if (findField) {
						this.sortDirection = findField.dir;
						return true;
					}
				} else {
					if (this.sort.field == this.field) {
						this.sortDirection = this.sort.dir;
						return true;
					}
				}
			}

			return false;
		},
		uniqueTooltipId() {
			return `${this.tableName}${this.field}`;
		}
	}
};
